/* unplugin-vue-components disabled */import script from "./MapSelectAddress.vue?vue&type=script&setup=true&lang=js"
export * from "./MapSelectAddress.vue?vue&type=script&setup=true&lang=js"

import "./MapSelectAddress.vue?vue&type=style&index=0&id=67ae3110&lang=css"

const __exports__ = script;

export default __exports__